import { useQrCreateStore } from '~~/stores/qrcreate';
import _ from 'lodash';
export default defineComponent({
  data() {
    return {
      used_colors: [],
    };
  },
  computed: {
    config() {
      const qrcreate = useQrCreateStore();
      return qrcreate.config;
    },
    imageData() {
      const qrcreate = useQrCreateStore();
      return qrcreate.imageData;
    },
  },
  methods: {
    CheckColorSelected(key, color) {
      if (this.config[key].color && color == this.config[key].color) {
        return true;
      }
      return false;
    },
    CheckGradientColorSelect(key, color) {
      if (this.config[key].gradient) {
        var colorsConfig = this.config[key].gradient.colorStops;
        var colorsArr = [];
        colorsConfig.forEach((item) => {
          colorsArr.push(item.color);
        });
        if (_.isEqual(_.sortBy(color), _.sortBy(colorsArr))) {
          return true;
        }
      }
      return false;
    },
  },
});
